import { Observable } from "rxjs"
import { ObservableFromFetch } from "../ObservableFromFetch"
import GeneralInformation, {PersonDemographicRecord, PersonDemographicObject, RegMode} from "./OrderResultModel/GeneralInformation"
import { GetUserId } from "../../storage/UserId"
import { UpdateMethodID } from "../../config/Constants"


  export const GeneralInformationGet = (PersonID: number) => ObservableFromFetch<GeneralInformation>("RandomTest/GetPersonnelGeneralInformation?personID="+PersonID)

  export function GeneralInformationSave(data: GeneralInformation | undefined): Observable<string> {
    const urlParams: string = new URLSearchParams({
      loginID: `${GetUserId()}`,
      updateMethodID: UpdateMethodID.toString()
    }).toString()
    const requestBody: string = JSON.stringify(data)
  
    return ObservableFromFetch<string>("/RandomTest/AddOrUpdatePerson?" + urlParams, requestBody, "PUT")
  }
  
  export const GetPersonDemographicsDetail = (PersonID: number) => ObservableFromFetch<PersonDemographicRecord>("RandomTest/GetPersonDemographicsDetail?personID="+PersonID)
  
  export  function UpdatePersonDemographic(data: PersonDemographicObject | undefined): Observable<string> {
    const urlParams: string = new URLSearchParams({
      regionID: '0',
      locationID: '0'
    }).toString()
    const requestBody: string = JSON.stringify(data)
  
    return ObservableFromFetch<string>("/RandomTest/UpdatePersonDemographicDetail?" + urlParams, requestBody, "POST")
  }
  
  export  function SaveRegulatoryMode(PersonID: number, items: RegMode[]): Observable<string> {
    const data = {
      PersonID: PersonID,
      RegEmpCatList: items
    }
    const requestBody: string = JSON.stringify(data)
  
    return ObservableFromFetch<string>("/RandomTest/SaveRegulatoryMode", requestBody, "POST")
  }
